// TODO: use global helpers instead
const filterMappings = {
  'status.name': (key, value) => `${key} eq '${value[0]}'`,
}

/**
 * Transform filter from activeFilters to resourceful format
 * @param {object} activeFilters
 * @returns {object} transformed filters
 * @example
 * activeFilters = {
 *  "status.name": { key: "status.name", value: ["DRAFT"] },
 *  "created_on": { key: "created_on", value: [...] },
 * }
 *
 * queryParamFilters = [
 *   "created_on lte 2023-08-29T17:00:00Z",
 *   "status.name eq 'DRAFT'",
 * ]
 */
export const transformFilter = (activeFilters) => {
  const filters = []

  for (let key of Object.keys(activeFilters)) {
    const filter = filterMappings[key]?.(key, activeFilters[key]) ?? undefined
    if (!filter) continue

    filters.push(filter)
  }

  return filters
}
